import window from 'global/window';

export const getLocalStorageValue = (key: string) => {
	try {
		return window.localStorage.getItem(key);
	} catch (e) {
		return null;
	}
};
